export default {
  label: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center'
  },
  closeIcon: {
    fontSize: '20px',
    margin: '10px 0 0 10px',
    paddingBottom: '10px',
    cursor: 'pointer'
  },
  expandIcon: {
    fontSize: '20px',
    margin: '10px 10px 0 10px',
    paddingBottom: '10px',
    cursor: 'pointer'
  }
};
